import { render } from "./StepProduct.vue?vue&type=template&id=33e2badd&scoped=true"
import script from "./StepProduct.vue?vue&type=script&lang=js"
export * from "./StepProduct.vue?vue&type=script&lang=js"

import "./StepProduct.vue?vue&type=style&index=0&id=33e2badd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e2badd"]])

export default __exports__